module.exports = __webpack_public_path__ + "images/dribbble_logo.png";